import * as React from 'react';
import MessageFormatFull from './components/MessageFormatFull';
import isMessageFormatOptionDirty from './utils/isMessageFormatOptionDirty';
import discardMessageFormatOption from './actions/discardMessageFormatOption';
import saveMessageFormatOption from './actions/saveMessageFormatOption';
var MessageFormatOption = {
    key: 'messageFormat',
    titleStringKey: 'optionTitle_messageFormat',
    searchTermsStringKey: 'optionTitle_messageFormat',
    fullOptionFormSettings: {
        render: function () { return React.createElement(MessageFormatFull, null); },
        isDirty: isMessageFormatOptionDirty,
        onSave: saveMessageFormatOption,
        onDiscard: discardMessageFormatOption,
    },
};
export default MessageFormatOption;
//# sourceMappingURL=MessageFormatOption.js.map